import { ReactElement } from 'react';
import { LoadingGradient } from '@provider-directory/components/loading-gradient/loading-gradient.component';
import { DecisionTreeContainer } from './decision-tree-container';

const DecisionTreeSkeleton = (): ReactElement => {
  return (
    <DecisionTreeContainer>
      <div className={'flex flex-col'}>
        <div className={'pb-2'}>
          <LoadingGradient className={'h-[32px] w-full rounded-sm'} />
        </div>
        <div className={'pb-7'}>
          <LoadingGradient className={'h-[32px] w-full rounded-sm pr-[57px]'} />
        </div>
        <div className={'pb-3'}>
          <LoadingGradient className={'h-[58px] w-full rounded-sm'} />
        </div>
        <div>
          <LoadingGradient className={'h-[58px] w-full rounded-sm'} />
        </div>
      </div>
    </DecisionTreeContainer>
  );
};

export default DecisionTreeSkeleton;
